import axios, { AxiosPromise } from 'axios';
import { IFtpDetail } from '../../../@types/model/masterData/ftpDetail/ftpDetail';
import { IFtpDetailUpsert } from '../../../@types/model/masterData/ftpDetail/ftpDetailUpsert';


export default class FtpDetailHttpService {
    public static getFtpDetailData() : AxiosPromise<Array<IFtpDetail>> {
        return axios.get(`${API_URL}/v1/FtpDetail/GetAllWeb`);
    }

    public static addOrUpdateFtpDetail(upsert : IFtpDetailUpsert) : AxiosPromise<IFtpDetail> {
        return axios.post(`${API_URL}/v1/FtpDetail/PostFtpDetail`, upsert);
    }

    public static deleteFtpDetail(ftpDetailId : number) : AxiosPromise<IFtpDetail> {
        return axios.delete(`${API_URL}/v1/FtpDetail/Delete`, {
            params: { ftpDetailId },
        });
    }
}
